<header class="header">
  <h1>
    <fa-icon [icon]="faUsersCog"></fa-icon>
    <span>HR Panel Administration</span>
  </h1>
</header>

<div class="container">
  <div class="registration-container">
    <div class="registration-form">
      <div class="form-header">
        <h2>
          <fa-icon [icon]="faBuilding"></fa-icon>
          <span>Register New Company</span>
        </h2>
      </div>
      
      <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
        <div class="section-title">
          <fa-icon [icon]="faUserShield"></fa-icon>
          <span>Admin User Details</span>
        </div>
        
        <div class="form-group">
          <label for="adminUsername">
            <fa-icon [icon]="faUser"></fa-icon>
            <span>Admin Username</span>
          </label>
          <input 
            type="text" 
            id="adminUsername" 
            formControlName="adminUsername"
            placeholder="Create an admin username"
            [ngClass]="{'is-invalid': registerForm.get('adminUsername')?.invalid && registerForm.get('adminUsername')?.touched}"
          >
          <div class="invalid-feedback" *ngIf="registerForm.get('adminUsername')?.invalid && registerForm.get('adminUsername')?.touched">
            <div *ngIf="registerForm.get('adminUsername')?.errors?.['required']">Username is required</div>
            <div *ngIf="registerForm.get('adminUsername')?.errors?.['minlength']">Username must be at least 3 characters</div>
          </div>
        </div>
        
        <div class="form-group">
          <label for="adminEmail">
            <fa-icon [icon]="faEnvelope"></fa-icon>
            <span>Admin Email</span>
          </label>
          <input 
            type="email" 
            id="adminEmail" 
            formControlName="adminEmail"
            placeholder="Enter admin email"
            [ngClass]="{'is-invalid': registerForm.get('adminEmail')?.invalid && registerForm.get('adminEmail')?.touched}"
          >
          <div class="invalid-feedback" *ngIf="registerForm.get('adminEmail')?.invalid && registerForm.get('adminEmail')?.touched">
            <div *ngIf="registerForm.get('adminEmail')?.errors?.['required']">Email is required</div>
            <div *ngIf="registerForm.get('adminEmail')?.errors?.['email']">Please enter a valid email</div>
          </div>
        </div>
        
        <div class="form-group">
          <label for="adminPassword">
            <fa-icon [icon]="faKey"></fa-icon>
            <span>Admin Password</span>
          </label>
          <input 
            type="password" 
            id="adminPassword" 
            formControlName="adminPassword"
            placeholder="Create a secure password"
            [ngClass]="{'is-invalid': registerForm.get('adminPassword')?.invalid && registerForm.get('adminPassword')?.touched}"
          >
          <div class="invalid-feedback" *ngIf="registerForm.get('adminPassword')?.invalid && registerForm.get('adminPassword')?.touched">
            <div *ngIf="registerForm.get('adminPassword')?.errors?.['required']">Password is required</div>
            <div *ngIf="registerForm.get('adminPassword')?.errors?.['minlength']">Password must be at least 6 characters</div>
          </div>
        </div>
        
        <div class="section-title">
          <fa-icon [icon]="faBuilding"></fa-icon>
          <span>Company Details</span>
        </div>
        
        <div class="form-group">
          <label for="companyName">
            <fa-icon [icon]="faBuilding"></fa-icon>
            <span>Company Name</span>
          </label>
          <input 
            type="text" 
            id="companyName" 
            formControlName="companyName"
            placeholder="Enter company name"
            [ngClass]="{'is-invalid': registerForm.get('companyName')?.invalid && registerForm.get('companyName')?.touched}"
          >
          <div class="invalid-feedback" *ngIf="registerForm.get('companyName')?.invalid && registerForm.get('companyName')?.touched">
            <div *ngIf="registerForm.get('companyName')?.errors?.['required']">Company name is required</div>
          </div>
        </div>
        
        <div class="form-group">
          <label for="companyAddress">
            <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
            <span>Company Address</span>
          </label>
          <input 
            type="text" 
            id="companyAddress" 
            formControlName="companyAddress"
            placeholder="Enter company address"
          >
        </div>
        
        <div class="form-group">
          <label for="companyPhone">
            <fa-icon [icon]="faPhone"></fa-icon>
            <span>Company Phone</span>
          </label>
          <input 
            type="text" 
            id="companyPhone" 
            formControlName="companyPhone"
            placeholder="Enter company phone"
          >
        </div>
        
        <div class="form-group">
          <label for="companyEmail">
            <fa-icon [icon]="faEnvelope"></fa-icon>
            <span>Company Email</span>
          </label>
          <input 
            type="email" 
            id="companyEmail" 
            formControlName="companyEmail"
            placeholder="Enter company email"
            [ngClass]="{'is-invalid': registerForm.get('companyEmail')?.invalid && registerForm.get('companyEmail')?.touched}"
          >
          <div class="invalid-feedback" *ngIf="registerForm.get('companyEmail')?.invalid && registerForm.get('companyEmail')?.touched">
            <div *ngIf="registerForm.get('companyEmail')?.errors?.['email']">Please enter a valid email</div>
          </div>
        </div>
        
        <div class="form-group">
          <label for="companyWebsite">
            <fa-icon [icon]="faGlobe"></fa-icon>
            <span>Company Website</span>
          </label>
          <input 
            type="text" 
            id="companyWebsite" 
            formControlName="companyWebsite"
            placeholder="Enter company website"
          >
        </div>
        
        <div class="buttons-container">
          <a routerLink="/hr/login" class="btn btn-secondary">
            <fa-icon [icon]="faArrowLeft"></fa-icon>
            <span>Back to Login</span>
          </a>
          <button type="submit" class="btn" [disabled]="isLoading || registerForm.invalid">
            <fa-icon [icon]="faPlusCircle"></fa-icon>
            <span>{{ isLoading ? 'Registering...' : 'Register Company' }}</span>
          </button>
        </div>
      </form>

      <div *ngIf="errorMessage" class="result-message error">
        <h3>
          <fa-icon [icon]="faExclamationCircle"></fa-icon>
          <span>Registration failed</span>
        </h3>
        <p>{{ errorMessage }}</p>
      </div>

      <div *ngIf="successMessage" class="result-message success">
        <h3>
          <fa-icon [icon]="faCheckCircle"></fa-icon>
          <span>Registration successful!</span>
        </h3>
        <p>Company <strong>{{ companyName }}</strong> has been created along with admin user <strong>{{ adminUsername }}</strong>.</p>
        <p>You can now <a routerLink="/hr/login" style="color: var(--success); text-decoration: none; font-weight: 600;">return to the login page</a> and sign in with these credentials.</p>
      </div>
    </div>
  </div>
</div>